// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2":"supplierOutbound","487":"supplierSku","627":"adminSku","665":"adminSupportCaseManagement"}[chunkId] + "." + {"2":"d06c0b9f","487":"d06c0b9f","627":"d06c0b9f","665":"d06c0b9f"}[chunkId] + ".chunk.css";
};